/* eslint-disable import/prefer-default-export */
import * as yup from "yup";

export const retailerId = yup.string().uuid().required().label("Retailer");

export const name = yup.string().min(2).trim().required().label("Name");

// export const distributionCenterIds = yup
//   .array()
//   .of(yup.string().uuid().required())
//   .ensure()
//   .default([])
//   .label("Distribution Centers");
